import {createContext, useCallback, useContext, useState} from 'react'

import PropTypes from 'prop-types'

const NetLoadingContext = createContext()

export const NetLoadingProvider = ({children}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [hasNetFinishedLoading, setHasJustFinished] = useState(false)

  const setNetLoading = useCallback(loading => {
    setIsLoading(prevLoading => {
      // Detect transition from true to false
      if (prevLoading && !loading) {
        setHasJustFinished(true)
      }
      return loading
    })
  }, [])

  const clearNetFinishedLoadingBadge = useCallback(() => {
    setHasJustFinished(false)
  }, [])

  return (
    <NetLoadingContext.Provider value={{isLoading, hasNetFinishedLoading, setNetLoading, clearNetFinishedLoadingBadge}}>
      {children}
    </NetLoadingContext.Provider>
  )
}

NetLoadingProvider.displayName = 'NetLoadingProvider'
NetLoadingProvider.propTypes = {
  children: PropTypes.node
}

export const useNetLoading = () => {
  const context = useContext(NetLoadingContext)

  if (!context) {
    return {
      isLoading: false,
      hasNetFinishedLoading: false,
      setNetLoading: () => {},
      clearNetFinishedLoadingBadge: () => {}
    }
  }

  return context
}
